<template>
  <div>
    <div class="checklist d-flex flex-wrap justify-content-around" data-toggle="checklist">
      <card v-for="section in sections" :key="section.name" class="w-30">
        <h4 slot="header">
          {{ section.name }}
        </h4>

        <ul class="list-group list-group-flush" data-toggle="checklist">
          <li v-for="(permission, i) in section.permissions" :key="permission.name" class="list-group-item px-0">
            <div :class="`checklist-item-${permissionType(i)}`" class="checklist-item">
              <div class="checklist-info justify-content-between w-100 d-flex">
                <h4 class="checklist-title mb-0" style="display: inline">
                  {{ permission.label }}
                </h4>
                <base-checkbox v-model="permission.included" style="display: inline" :type="permissionType(i)" />
              </div>
            </div>
          </li>
        </ul>
      </card>
    </div>

    <div class="text-right mt-3">
      <base-button native-type="submit" type="primary" @click="save"> Guardar </base-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    role: {
      type: Object,
      default: () => {
        return {
          id: 0,
          name: '',
          label: '',
          permissions: [],
        };
      },
    },

    permissions: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      types: ['info', 'primary', 'warning', 'danger', 'success', 'dark'],
      sections: [],
    };
  },

  computed: {
    permissionType() {
      return (index) => {
        return this.types[index % this.types.length];
      };
    },
  },

  mounted() {
    this.sections = [];
    this.setSections();
  },

  methods: {
    save() {
      this.$emit('save', this.getPermissionsToSave());
    },

    getPermissionsToSave() {
      let permissions = this.sections.reduce((r, k) => r.concat(k.permissions), []);
      return permissions.filter((c) => c.included);
    },

    setSections() {
      this.permissions.forEach((p) => {
        p.included = !!this.role.permissions.find((i) => i.name === p.name);
        this.addSection(p.section, p.label, p);
      });
    },

    addSection(name, label, p) {
      const index = this.sections.findIndex((s) => s.name === name);

      if (index === -1) {
        this.sections.push({ name, label, permissions: [p] });
      } else {
        this.sections[index].permissions.push(p);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.w-30 {
  width: 30% !important;
}

.form-check {
  margin-top: -1em;
  position: absolute;
  right: 0;
}
</style>
